var badgeData = {
  name: "badge",
  data: [{
    bgColor: "#FF5656",
    borderColor: "#FF5656",
    fontColor: "#fff",
    fontSize: 12,
    radius: 15,
    height: 18,
    dotSize: 8
  }]
};
export default badgeData;